import e from "./extends.mjs";
import { isHostComponent as o } from "./isHostComponent.mjs";
function a(t, n, r) {
  return t === void 0 || o(t) ? n : e({}, n, {
    ownerState: e({}, n.ownerState, r)
  });
}
export {
  a as appendOwnerState
};
//# sourceMappingURL=appendOwnerState.mjs.map
